import { Language } from '../../common/url-query-params';

export const generateURLQuery = (iso: string) => {
  return [Language, '=', iso].join('');
};
